import { render } from "./ClubView.vue?vue&type=template&id=753f4aa5&scoped=true"
import script from "./ClubView.vue?vue&type=script&lang=js"
export * from "./ClubView.vue?vue&type=script&lang=js"

import "./ClubView.vue?vue&type=style&index=0&id=753f4aa5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-753f4aa5"]])

export default __exports__